import React from "react";
import { formatTemperature } from "../../../helpers/formatters/temperature";
import { useLocationSummary } from "../../../network/matlocq/queries/LocationSummary";
import { WeatherIcon } from "../../WeatherIcon";
import styles from "./styles.module.scss";

type Props = {
    code: string;
    removeFavorite: (code: string) => void;
};

export const FavoriteOverlayItem: React.FC<Props> = ({
    code,
    removeFavorite,
}) => {
    const { data: favorite } = useLocationSummary(code);

    if (!favorite?.location?.slug) {
        return null;
    }

    return (
        <div className={styles.overlayItem}>
            <a
                className={styles.overlayLink}
                href={`/${favorite.location.slug}`}
            >
                <div className={styles.overlayName}>
                    {favorite.location.name}
                </div>
                <div>
                    <WeatherIcon
                        url={
                            favorite.forecastSummary.items[0]?.weatherAggregated
                                ?.iconUrl ?? null
                        }
                        alt={
                            favorite.forecastSummary.items[0]?.weatherAggregated
                                ?.text ?? ""
                        }
                        title={
                            favorite.forecastSummary.items[0]?.weatherAggregated
                                ?.text ?? ""
                        }
                        imgTagSize={{
                            width: 54,
                            height: 34,
                        }}
                        lazyloadImage={false}
                    />
                </div>
                <div>
                    <span className={styles.overlayTemperatureMax}>
                        {formatTemperature(
                            favorite.forecastSummary.items[0]?.temperature?.max
                        )}
                    </span>
                    <span className={styles.temperatureMin}>
                        &nbsp;/&nbsp;
                        {formatTemperature(
                            favorite.forecastSummary.items[0]?.temperature?.min
                        )}
                    </span>
                </div>
            </a>
            <button
                onClick={() => removeFavorite(favorite?.location?.code ?? "")}
                className={styles.overlayActions}
            >
                <span className="icon-bin" />
            </button>
        </div>
    );
};
